import { memo } from "react";
import cx from "classnames";
import { IonContent } from "@ionic/react";
import { WLLoader } from "../../../../../Common/components/WLLoader/WLLoader";
import WLDialog from "../../../../components/WLDialog/WLDialog";
import LoginOTPLogoRow from "./LoginOTPLogoRow";
import LoginOTPVerificationPanel from "./LoginOTPVerificationPanel";

import s from "./LoginOTPContent.module.scss";

const LoginOTPContent: React.FC = (): JSX.Element => {
  return (
    <IonContent className={cx(s.pageContent)} scrollY fullscreen>
      <div className={s.body}>
        <LoginOTPLogoRow />
        <LoginOTPVerificationPanel />
      </div>

      <WLLoader />
      <WLDialog />
    </IonContent>
  );
};

export default memo(LoginOTPContent);
